<template>
    <div class="slot-accordion-wrapper" :class="className">
        <div class="flex-center actionBar" @click="actionBarClicked">
            <div :class="{sticky: sticky}" :style="{width: tableWidth}">
                <div v-if="showMoveIcons" class="move" :class="{noEdit: !editAllowed}">
                    <span @click="moveUp" class="icon icon-sort-up" :class="{sticky: sticky}"></span>
                    <span @click="moveDown" class="icon icon-sort-down" :class="{sticky: sticky}"></span>
                </div>
                <div @click="$emit('editSpaceClicked')" class="wrapper" :style="{marginLeft: $route.name !== 'showReporting' && title !== 'Zusammenfassung' ? '25px' : ''}">
                    <InputDetail v-if="titleEditable && editAllowed" font-size="15px" font-weight="700" class="title"
                                 :background="'none'" :border="'none'" :value="this.title" :autoWidth="true"
                                 @input="titleChanged($event)"></InputDetail>
                    <span class="title" :class="{noEdit: !editAllowed}" v-if="!titleEditable || !editAllowed"
                          :style="{paddingLeft: titlePadding}">{{title}}</span>
                </div>
                <div v-if="!disableAdd && editAllowed" class="icon actionIcon">
                    <span @click="addElement" class="icon-add"></span>
                </div>
                <div v-if="!disableDuplicate && editAllowed" class="icon actionIcon">
                    <span @click="copyElement" class="icon-duplicate"></span>
                </div>
                <div v-if="!disableDelete && editAllowed" class="icon actionIcon">
                    <span @click="deleteElement" class="icon-delete"></span>
                </div>
                <span @click="iconTriggerClicked" class="accordion-item-trigger-icon"
                      v-bind:class="{ 'is-active': active }"></span>
            </div>
        </div>
        <transition name="fade" mode="out-in">
            <slot name="content" v-if="active"></slot>
        </transition>
        <slot name="visible"></slot>
    </div>
</template>

<script>
    import InputDetail from "../inputs/InputDetail";

    export default {
        name: "SlotAccordion",
        components: {
            InputDetail
        },
        props: {
            title: {
                type: String,
                required: true
            },
            titleEditable: {
                type: Boolean,
                required: false,
                default: false
            },
            disableAdd: {
                type: Boolean,
                default: false
            },
            disableDuplicate: {
                type: Boolean,
                default: false
            },
            disableDelete: {
                type: Boolean,
                default: false
            },
            className: {
                required: false
            },
            sticky: {
                type: Boolean,
                default: false
            },
            showMoveIcons: {
                type: Boolean,
                default: false
            },
            moveIndex: {
                default: false
            },
            startOpen: {
                type: Boolean,
                default: true,
            },
            type: {
                typee: String,
                default: 'default'
            },
            space: { //currently used only if type === 'space' to see if its an initial space
                type: Object,
                required: false
            }

        },
        data: () => {
            return {
                active: true
            }
        },
        computed: {
            tableWidth() {
                let clientRect = this.$store.state.trackingList.tableClientRect;
                let width;
                if (clientRect) {
                    width = window.innerWidth < clientRect.width ? window.innerWidth : clientRect.width;
                    return (width - 20) + 'px';
                } else {
                    return '100%';
                }
            },
            titlePadding() {
                if (this.$route.name === "showReporting") {
                    return '20px';
                } else {
                    if (this.titleEditable) {
                        return '0';
                    } else {
                        return '20px';
                    }
                }
            },
            editAllowed() {
                let status = this.$store.state.trackingList.data.status;
                if (typeof status !== "undefined") {
                    if (status.indexOf('eingebaut') !== -1) {
                        //status is pink
                        if (this.type.toLowerCase() === 'space' && Object.prototype.hasOwnProperty.call(this.space, 'initial') && this.space.initial) {
                            //initial space
                            return false;
                        } else if (this.type.toLowerCase() === 'space' && (!Object.prototype.hasOwnProperty.call(this.space, 'initial') || !this.space.initial)) {
                            //not an initial space
                            return true;
                        }
                    }
                }
                return true;
            }
        },
        methods: {
            iconTriggerClicked(event) {
                this.active = !this.active;
                event.stopPropagation();
            },
            actionBarClicked(event) {
                if (event.target.nodeName !== 'INPUT' && event.target.className.indexOf('icon-sort') === -1) {
                    this.active = !this.active;
                }
                if(this.active){
                    window.requestAnimationFrame(() => {
                        this.$emit('accordionCollapse');
                    });
                } else{
                    setTimeout(()=>{
                        this.$emit('accordionCollapse');
                    }, 400);

                }
            },
            titleChanged(title) {
                this.$emit('spaceNameChanged', title);
            },
            addElement: function (ev) {
                this.$emit('addElement');
                ev.stopPropagation();
            },
            copyElement: function (ev) {
                this.$emit('copyElement');
                ev.stopPropagation();
            },
            deleteElement: function (ev) {
                this.$emit('deleteElement');
                ev.stopPropagation();
            },
            accordionAction: function (ev) {
                this.$emit('accordionAction');
                ev.stopPropagation();
            },
            moveUp: function () {
                this.$emit('moveUp', (this.moveIndex));
            },
            moveDown: function () {
                this.$emit('moveDown', (this.moveIndex));
            }
        },
        created() {
            this.active = this.startOpen;
            this.$emit('created');
        }
    }
</script>

<style lang="scss" scoped>
    .slot-accordion-wrapper {
        margin-bottom: 5px;
        width: max-content;
        min-width: 100%;
        position: relative;
    }

    .accordion-item-trigger-icon {
        $size: 13px;
        display: block;
        position: absolute;
        top: 0;
        right: 1.25rem;
        bottom: 0;
        margin: auto;
        width: $size;
        height: $size;
        border-right: 2px solid #363636;
        border-bottom: 2px solid #363636;
        transform: translateY(calc(#{-$size} / 4)) rotate(45deg);
        transition: transform 0.2s ease;

        .is-active & {
            transform: translateY(calc(#{-$size} / 4)) rotate(225deg);
        }
    }

    .actionIcon {
        display: inline-block;
        padding: 0.7em 0.7em 0.3em 0.7em;
        cursor: pointer;
    }

    .icon-add {
        color: #d70364;
    }

    .mainIcon {
        padding: .2em;
        padding-right: 1em;
    }

    .actionIcon span {
        font-size: 1.3em;
    }

    .mainIcon span {
        font-size: 3.2em;
        font-weight: bold;
        color: $pink;
        display: flex;
        align-items: center;
    }

    .title {
        font-weight: bold;
        font-size: 15px;
        color: black;
    }

    .wrapper {
        align-items: center;
        display: flex;
        min-width: 165px;
        height: 30px;

        ::v-deep input {
            padding: 5px;
        }
    }

    .flex-center {
        display: flex;
        align-items: center;
    }

    .actionBar {
        min-height: 54px;
        position: relative;
        background-color: #fff;
        z-index: 1;
    }

    span {
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        -o-user-select: none;
    }

    .sticky {
        position: sticky;
        left: 3px;
        display: flex;
        align-items: center;
    }

    .move {
        position: absolute;
        top: 0;
        left: 6px;
        display: flex;
        flex-flow: column;
        height: 36px;
        justify-content: space-between;
        font-size: 12px;
        color: $grey;
        padding: 4px 3px;
        margin-top: 2px;
        cursor: pointer;

        &.noEdit {
            top: -6px;
        }
    }

</style>